import m from "mithril";
import MessageProvider from "../../../MessageProvider"
import DateRangeComponent from "../../common/DateRangeComponent"
import SpinnerBoxComponent from '../../common/SpinnerBoxComponent';
import HotelSearchFormState from "../../../states/HotelSearchFormState";
import { getValueByLang } from "../../../Utils";
import './SearchFormComponent.css'
import '../../common/ToolTip.css';

interface Attrs {
    messageProvider: MessageProvider;
    hotelSearchFormState: HotelSearchFormState;
    isOnDesktop: boolean,
    isOpeningDialog?: boolean,
    onSearchClick: () => void;
    onLocationClick: () => void;
    onDateRangePickerClick: () => void;
}
let showRequiredLocationMessage = false;
let showRequiredGuestTypeMessage = false;
let showRequiredDateRangeMessage = false;
let isSearched = false;

function updateShowingMessage() {
    showRequiredLocationMessage = false;
    showRequiredGuestTypeMessage = false;
    showRequiredDateRangeMessage = false;  
}

const SearchFormComponent: m.Component<Attrs> = {
    oninit(vnode) {
        updateShowingMessage();
    },
    onbeforeupdate(vnode){
        showRequiredLocationMessage = !vnode.attrs.isOpeningDialog && isSearched && !vnode.attrs.hotelSearchFormState.location;
        showRequiredDateRangeMessage = !showRequiredLocationMessage && !vnode.attrs.isOpeningDialog && isSearched && !vnode.attrs.hotelSearchFormState.checkInDate;
        showRequiredGuestTypeMessage = !showRequiredLocationMessage && !showRequiredDateRangeMessage && !vnode.attrs.isOpeningDialog && isSearched && !vnode.attrs.hotelSearchFormState.guestType;
    },
    view(vnode) {
        const { messageProvider, hotelSearchFormState, isOnDesktop, onSearchClick, onLocationClick, onDateRangePickerClick } = vnode.attrs;
        const formGridClass = (isOnDesktop)? "search-form-grid-desktop" : "search-form-grid-mobile";

        return m("div", { class: (isOnDesktop)? "rounded-16": "mx-3 p-3 bg-primary-light rounded-16" }, [
            m("form", { class: "non-selectable search-form-grid " + formGridClass }, [
                m("div", { 
                    id: "location-selection",
                },
                    m("div", {
                        class: showRequiredLocationMessage? "p-2 shadow-sm rounded clickable border-primary border bg-white": "p-2 shadow-sm rounded clickable border bg-white",
                        id: "location-selection",
                        onclick: function (event) {
                            event.preventDefault();
                            onLocationClick()
                            updateShowingMessage();
                        }
                    }, [
                        m("i.bi bi-geo-alt text-primary"),
                        (hotelSearchFormState.location) ?
                            m("span", { class: "pl-2" },
                                (hotelSearchFormState.location.type.toString() == "ATTRACTION") ?
                                    [
                                        getValueByLang(hotelSearchFormState.location.name, messageProvider.getCurrentLang()),
                                        m("small.text-muted", " (" + messageProvider.get("nearby") + ")")
                                    ] :
                                    getValueByLang(hotelSearchFormState.location.name, messageProvider.getCurrentLang())
                            ) :
                            m("span", { class: "pl-2 text-muted" }, messageProvider.get("location"))
                    ]),
                    showRequiredLocationMessage?
                    m("div.tooltip",
                        m("span.tooltiptext.mt-2", messageProvider.get("required_destination"))
                    ):null,

                ),
                
                m("div", { id: "date-selection" },
                    m(DateRangeComponent, {
                        showHightLight: showRequiredDateRangeMessage,
                        checkin: hotelSearchFormState.checkInDate,
                        checkout: hotelSearchFormState.checkOutDate,
                        checkinPlaceholder: messageProvider.get("checkin_date"),
                        checkoutPlaceholder: messageProvider.get("checkout_date"),
                        singularNightLabel: messageProvider.get("night"),
                        pluralNightLabel: messageProvider.get("nights"),
                        onDateRangePickerClick: function () {
                            onDateRangePickerClick()
                            updateShowingMessage();
                        }
                    }),
                    showRequiredDateRangeMessage?
                    m("div.tooltip",
                        m("span.tooltiptext.mt-2", messageProvider.get("required_dates"))
                    ):null,
                ),

                m("div", {
                    id: "room-count-option"
                },
                    m(SpinnerBoxComponent, {
                        placeholder: messageProvider.get("number_of_room"),
                        singularLabel: messageProvider.get("room"),
                        pluralLabel: messageProvider.get("rooms"),
                        initialValue: hotelSearchFormState.numberOfRooms,
                        minCount: 1,
                        maxCount: 4,
                        onCountChange: function (newValue) {
                            hotelSearchFormState.numberOfRooms = newValue;
                        }
                    })
                ),

                m("div", {
                    class: "",
                    id: "traveller-type-option"
                },
                    m("div.d-flex align-items-center ", {
                        class: (isOnDesktop)? "": "border rounded bg-white"
                    },[
                        m("div.clickable py-2 ", {
                            class: (isOnDesktop)? "px-2": "pl-2 flex-fill border-right",
                            onclick: function () {
                                hotelSearchFormState.guestType = "LOCAL";
                            }
                        }, [
                            (
                                (hotelSearchFormState.guestType == "LOCAL") ?
                                m("i.bi bi-record-circle text-primary"):
                                m("i.bi bi-circle text-primary")
                            ),
                            m("span.pl-2", messageProvider.get("local"))
                        ]),
                        m("div.clickable py-2 pl-2 ", {
                            class: (isOnDesktop)? "": "flex-fill",
                            onclick: function () {
                                hotelSearchFormState.guestType = "FOREIGNER";
                            }
                        }, [
                            (
                                (hotelSearchFormState.guestType == "FOREIGNER") ?
                                m("i.bi bi-record-circle text-primary"):
                                m("i.bi bi-circle text-primary")
                            ), 
                                m("span.pl-2", messageProvider.get("foreigner"))
                        ])
                    ]
                    ),
                    showRequiredGuestTypeMessage?
                    m("div.tooltip",
                        m("span.tooltiptext.mt-2",{
                            class: messageProvider.getCurrentLang() =='en' ? " left-percent-6 " : " left-percent-15 "
                        } ,
                        messageProvider.get("required_guest_type"))
                    ):null
                    
                ),

                m("div", { id: "submit-button" }, [
                    m("div", [
                        (hotelSearchFormState.isValid()) ?
                            [
                                m("button", {
                                    class: "text-white btn btn-block btn-primary shadow-sm rounded mmd-ripple raised pt-2 pb-2",
                                    onclick: function (event) {
                                        event.preventDefault();
                                        onSearchClick();
                                    }
                                }, m("i.bi bi-search text-white-dark px-2"), m("strong.text-white-dark", messageProvider.get("search")))
                            ] :
                            m("button", {
                                class: "text-white btn btn-block btn-primary shadow-sm rounded mmd-ripple raised pt-2 pb-2",
                                onclick: function (event) {
                                    event.preventDefault();
                                    isSearched=true;
                                }
                            }, m("i.bi bi-search text-white-dark px-2"), m("strong.text-white-dark", messageProvider.get("search")))
                    ])
                ])

            ])
        ])
    }
};

export default SearchFormComponent;

